import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModelCase } from 'src/app/logic/model/case.model';
import { LibLoading } from 'src/app/logic/lib/loading.lib';

@Component({
  selector: 'app-modal-add-case',
  templateUrl: './add-case.component.html',
})

export class ModalAddCaseComponent implements OnInit {

  image: File;

  formGroup = new FormGroup({
    name: new FormControl('', [
      Validators.required,
    ]),
    description: new FormControl(''),
  });

  constructor(
    public dialogRef: MatDialogRef<ModalAddCaseComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public projectId: string,
    private loading: LibLoading,
    private modelCase: ModelCase) { }

  ngOnInit() { }

  onSubmit() {
    this.loading.show();
    this.modelCase.addCase(this.projectId, this.formGroup.value.name, this.formGroup.value.description, this.image).subscribe(
      () => {
        this.loading.hide();
        this.dialogRef.close(true);
      },
      (error) => {
        this.loading.hide();
        alert('エラー');
      }
    );
  }
}


